<template>
  <v-card
    class="d-flex align-center justify-center"
    @drop.prevent="onDrop"
    @dragover.prevent
    @dragenter.prevent
    @click="images.length === 0 ? triggerFileInput() : null"
    :style="{
      width: width + 'px',
      height: height + 'px',
      position: 'relative',
      borderRadius: '20px',
      justifySelf: 'center',
      backgroundColor: '#d9d9d9',
    }"
  >
    <input
      multiple
      accept="image/*"
      type="file"
      @change="onFileChange"
      class="d-none"
      hide-input
      ref="fileInput"
    />

    <div class="image-container-wrapper">
      <v-hover>
        <template v-slot:default="{ hover }">
          <div
            :style="{
              height: images.length === 0 ? '' : '100%',
              width: ' 100%',
              borderRadius: '12px',
            }"
          >
            <img
              v-for="(img, index) in images"
              :key="index"
              :src="img"
              :alt="'Imagem ' + (index + 1)"
              :class="index === 0 ? 'main-image' : 'thumbnail'"
              @click="index === 0 ? deleteImage(img) : null"
            />
            <v-fade-transition>
              <v-overlay
                v-if="hover && images.length > 0"
                absolute
                color="#D70200"
                :style="{
                  borderRadius: '20px',
                }"
              >
                <v-icon
                  size="50"
                  class="red--text"
                  @click.stop="deleteImage(images[0])"
                  >mdi-delete-outline</v-icon
                >
              </v-overlay>
            </v-fade-transition>
          </div>
        </template>
      </v-hover>

      <div
        v-for="(img, index) in images.slice(1)"
        :key="index"
        class="thumbnail-wrapper"
      >
        <v-hover>
          <template v-slot:default="{ hover }">
            <div>
              <img
                :src="img"
                :alt="'Imagem ' + (index + 2)"
                class="thumbnail"
              />
              <v-fade-transition>
                <v-overlay
                  v-if="hover"
                  absolute
                  color="#D70200"
                  :style="{
                    zIndex: 1000,
                    position: 'absolute',
                    top: '-20px',
                    left: '-10px',
                    width: '30px',
                    height: '30px',
                    borderRadius: '8px',
                  }"
                >
                  <v-icon
                    size="20"
                    class="red--text"
                    @click.stop="deleteImage(img)"
                    >mdi-delete-outline</v-icon
                  >
                </v-overlay>
              </v-fade-transition>
            </div>
          </template>
        </v-hover>
      </div>

      <v-btn
        v-if="images.length > 0 && images.length < 4"
        icon
        small
        @click.stop="triggerFileInput"
        class="add-button white--text"
        :loading="loadingImages"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <div
        class="d-flex flex-column align-center justify-start"
        v-if="!images.length"
      >
        <v-icon
          :style="{
            padding: '8px',
            backgroundColor: '#ccc',
            borderRadius: '50%',
          }"
        >
          mdi-cloud-upload
        </v-icon>
        <span
          :style="{ fontSize: '12px', textAlign: 'center' }"
          v-html="$t('common.insert-product-image')"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import { uploadEventImage } from "../../api";
import { mapGetters } from "vuex";

export default {
  name: "BaseImageInput",
  props: {
    edit: {
      default: [],
    },
    width: {
      type: Number,
      default: 120,
    },
    height: {
      type: Number,
      default: 120,
    },
    productVariationId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fileInput: null,
      files: [],
      images: [...this.edit],
      loadingImages: false,
    };
  },
  computed: {
    ...mapGetters(["storeSequencial", "getSlug", "getIdEvent"]),
  },
  methods: {
    getTimestamp() {
      const date = new Date();

      const formattedDate =
        date.getFullYear() +
        "_" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "_" +
        String(date.getDate()).padStart(2, "0") +
        "_" +
        String(date.getHours()).padStart(2, "0") +
        "_" +
        String(date.getMinutes()).padStart(2, "0") +
        "_" +
        String(date.getSeconds()).padStart(2, "0") +
        "_" +
        String(date.getMilliseconds()).padStart(4, "0");

      return formattedDate;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const files = event.target.files || event;
      let acc = 0;
      for (let file of files) {
        if (this.images.length < 4) {
          acc++;
          setTimeout(() => {
            this.readFile(file);
          }, 10 * acc);
        } else {
          break;
        }
      }
      event.target.value = null;
    },
    onDrop(event) {
      const files = event.dataTransfer.files;
      let acc = 0;
      for (let file of files) {
        if (this.images.length < 4) {
          acc++;
          setTimeout(() => {
            this.readFile(file);
          }, 10 * acc);
        } else {
          break;
        }
      }
    },
    async readFile(file) {
      this.loadingImages = true;
      const reader = new FileReader();
      reader.onload = async e => {
        const img_base64 = e.target.result;

        try {
          const response = await uploadEventImage({
            file: img_base64,
            store: this.storeSequencial,
            image: "imagem1",
            productVariationId: this.productVariationId,
            product: this.getIdEvent,
            slug: this.getSlug,
            timestamp: this.getTimestamp(),
          });
          const imageUrl = response.data.url;
          this.images.push(imageUrl);
          this.$emit("update:updateImage", this.images);
        } catch (error) {
          console.error("Erro ao fazer upload da imagem", error);
        } finally {
          this.loadingImages = false;
        }
      };
      reader.readAsDataURL(file);
    },
    deleteImage(img) {
      this.images.splice(this.images.indexOf(img), 1);
      this.$emit("update:updateImage", this.images);
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.image-container-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.main-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 15px;
}

.thumbnail-wrapper {
  position: absolute;
  bottom: 0px;
  left: 0px;
  background: (0, 0, 0, 0.5);
}

.thumbnail-wrapper + .thumbnail-wrapper {
  position: absolute;
  bottom: 0px;
  left: 30px;
  background: (0, 0, 0, 0.5);
}

.thumbnail-wrapper + .thumbnail-wrapper + .thumbnail-wrapper {
  position: absolute;
  bottom: 0px;
  left: 60px;
  background: (0, 0, 0, 0.5);
}

.thumbnail {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 8px;
  position: absolute;
  bottom: -10px;
  left: -10px;
  border: 1px solid #ccc;
  z-index: 10;
}

.add-button {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background-color: #6200ea;
  color: white;
  z-index: 10;
}
</style>
